/*
 * @Descripttion: 
 * @version: 
 * @Author: Royalzxl
 * @Date: 2020-04-07 09:42:02
 * @LastEditors: Royalzxl
 * @LastEditTime: 2020-04-07 15:22:21
 */

import confirm from "./confirm/confirm";
import tips from "./tips/tips";


export {
    confirm,
    tips
}